// jquery-global.js
// https://stackoverflow.com/questions/35358625/jquery-is-not-defined-when-use-es6-import

import $ from 'jquery';
window.$ = $;
window.jQuery = $;